/**
 * epgCard.tsx
 */
import Card from '@shared/types/props/card';
import EpgCardContainer from '@components/atoms/container/epgCardContainer';
import EpgCardTitle from '@components/atoms/text/epgCardTitle';
import useEpgCard from '../../lib/useEpgCard';
import { memo } from 'react';

function EpgCard(parentProps: Card) {
  // Card hook
  const { props, ref } = useEpgCard(parentProps);
  // Render
  return props.container.width > 0 ? (
    <EpgCardContainer {...props.container} ref={ref}>
      <EpgCardTitle {...props.title}>{parentProps.item.title}</EpgCardTitle>
    </EpgCardContainer>
  ) : (
    <></>
  );
}

export default memo(EpgCard);
